module.exports = {"Credit4":{"daobanList":[{"title":"1: 你是遗失要补办居民身份证吗？","index":0,"state":-1,"values":[{"name":"是的","canNext":true,"selected":0,"cailiaoList":[{"name":"居民身份证数字相片采集检测回执","state":"必要"}]},{"name":"不是","selected":0,"cailiaoList":[{"name":"居民身份证数字相片采集检测回执","state":"必要"}]}]},{"title":"2:你是否要同时办理临时身份证？","index":1,"state":-1,"values":[{"name":"是的","selected":0,"cailiaoList":[{"name":"监护关系承诺书","state":"必要"}]},{"name":"不是","selected":0,"cailiaoList":[{"name":"监护关系承诺书","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdc-4.json
// module id = 1238
// module chunks = 0